import script from "./TopElectronics.vue?vue&type=script&setup=true&lang=js"
export * from "./TopElectronics.vue?vue&type=script&setup=true&lang=js"

import "./TopElectronics.vue?vue&type=style&index=0&id=1f25268f&lang=css"

const __exports__ = script;

export default __exports__